import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardPetitionerComponent } from './dashboard-petitioner.component';
import { BulkUploadListComponent } from '../i9-evaluators/bulk-upload/bulk-upload-list/bulk-upload-list.component';
import { BeneListComponent } from '../beneficiary/bene-list/bene-list.component';
//import { PetitionAuditLogComponent } from '../dashboard/components/task/petition-audit-log/petition-audit-log.component';
const dashboardRoutes: Routes = [
    {
        path: 'petitioner-dashboard',
        pathMatch: 'full',
        component: DashboardPetitionerComponent
    },
    {
        path: 'i9-admin-dashboard',
        pathMatch: 'full',
        component: DashboardPetitionerComponent
    },
    {
        path: 'petitioner-dashboard/scheduling', //EmailClientModule
        loadChildren: () => import('../scheduling/scheduling.module').then((mod) => mod.SchedulingModule),
    },
    {
        path: 'petitioner-dashboard/email-client', //EmailClientModule
        loadChildren: () => import('../email-client/email-client.module').then((mod) => mod.EmailClientModule),
    },
    {
        path: 'petitioner-dashboard/alerts',
        loadChildren: () => import('../../modules/alerts/messageAlert.module').then((mod) => mod.MessageAlertModule)
       
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'petitioner-dashboard'
    },
    {
        path: 'task-list',
        loadChildren: () => import('../dashboard/dashboard.module').then((mod) => mod.DashboardModule),
    },
    {
        path: 'petitioner-landing/bulk-upload-list',
        component: BulkUploadListComponent,
    },
    {
        path: 'beneficiaries/list',
        component: BeneListComponent,
    },
];


@NgModule({
    imports: [RouterModule.forChild(dashboardRoutes)],
    exports: [RouterModule],
    providers: []
})
export class PetitionerDashboardRoutingModule { }
